export function getDateString(date) {
    var dateTimeFormat = new Intl.DateTimeFormat("en", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
    var _a = dateTimeFormat.formatToParts(date), month = _a[0].value, day = _a[2].value, year = _a[4].value;
    return "".concat(year, "-").concat(month, "-").concat(day);
}
